import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PipeClassViewModel } from 'src/app/shared/models/autogenerated-piping';
import { ClonePipeClassDialogComponent, ClonePipeClassDialogData } from 'src/app/search/clone-pipe-class-dialog/clone-pipe-class-dialog.component';

@Component({
  selector: 'app-clone-pipe-class-button',
  templateUrl: './clone-pipe-class-button.component.html',
  styleUrls: ['./clone-pipe-class-button.component.scss'],
  standalone: false,
})
export class ClonePipeClassButtonComponent {
  @Input() pipeClass: PipeClassViewModel;

  constructor(private readonly dialog: MatDialog) {}

  openCloneDialog(): void {
    if (!this.pipeClass?.id) { return; }

    const dialogData: ClonePipeClassDialogData = {
      sourcePipeClassId:   this.pipeClass.id,
      prefillBusinessUnit: this.pipeClass.businessUnits?.[0],
      prefillApplication:  this.pipeClass.application,
      showDraftInfoMessage: false,
    };

    this.dialog.open(ClonePipeClassDialogComponent, {
      width: '650px',
      disableClose: false,
      data: dialogData,
    });
  }
}
